export default __webpack_public_path__ + "static/media/Ballroll_00293.4d5b044c.png";